import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import styled from 'styled-components'

import useAxios, { mutate } from 'hooks/useAxios'
import { toastr } from 'libs/toast'
import SurveyConfigOptionsContainer from 'components/SurveyConfigOptions/container'
import { surveySettingContext } from 'pages/SurveySettings/context'
import EmailSurveyHeaderActionButton from 'components/EmailSurveyHeaderActionButton'
import WebEmbedSurveyHeaderActionButton from 'components/WebEmbedSurveyHeaderActionButton'
import { generatePreviewLink } from './SurveySettingsV2/utils'
import { AllowPermission } from '../shared/components/AllowPermission'
import { AdminHeader } from '../pages/Admin'
import constants from 'config/constants'

const Control = styled.div`
  margin-left: auto;
`

function SurveySettingsHeader({ emailDeliverySetting, survey, updateEmailDeliverySetting }) {
  const { currentSaveFunction, isSubmitting, isSaveButtonHidden, isDisabled } =
    useContext(surveySettingContext)

  const isSurveyActive = survey.status === 'active'
  const onUpdateStatus =
    (live, onSuccess = () => {}) =>
    async () => {
      isSurveyActive && (await updateEmailDeliverySetting.callApi({ live }))

      if (updateEmailDeliverySetting.success) {
        onSuccess()
        live
          ? toastr.success('This survey has been set live!')
          : toastr.success('This survey has been paused. Set live to resume sending.')
      }

      if (updateEmailDeliverySetting.error) {
        toastr.error('Something went wrong, please try again.')
      }
    }

  const onPauseSurvey = onUpdateStatus(false)

  const createOnSetSurveyLive = (onSuccess) => onUpdateStatus(true, onSuccess)

  return (
    <AdminHeader
      pageHeaderName={survey.name}
      survey={survey}
      isOngoingEmailLive={emailDeliverySetting.live}
    >
      <React.Fragment>
        <Control>
          <React.Fragment>
            <a href={generatePreviewLink(survey.token)} target="_blank" rel="noopener">
              <Button type="button" basic>
                <i className="fas fa-eye icon" />
                Preview
              </Button>
            </a>
            <AllowPermission permission={constants.permissions.manageSurveys}>
              <EmailSurveyHeaderActionButton
                className="mr1"
                survey={survey}
                isOngoingEmailLive={emailDeliverySetting.live}
                loading={updateEmailDeliverySetting.loading}
                onPauseSurvey={onPauseSurvey}
                createOnSetSurveyLive={createOnSetSurveyLive}
              />
              {survey.type === 'web_embed' && <WebEmbedSurveyHeaderActionButton survey={survey} />}
              <Button
                className="mr1"
                primary
                onClick={currentSaveFunction}
                disabled={isDisabled || isSubmitting}
                loading={isSubmitting}
                style={{ display: `${isSaveButtonHidden ? 'none' : ''}` }}
              >
                Save
              </Button>
            </AllowPermission>
            <SurveyConfigOptionsContainer survey={survey} />
          </React.Fragment>
        </Control>
      </React.Fragment>
    </AdminHeader>
  )
}

SurveySettingsHeader.propTypes = {
  survey: PropTypes.object,
  emailDeliverySetting: PropTypes.object,
  updateEmailDeliverySetting: PropTypes.object,
}

function SurveySettingsHeaderContainer(props) {
  const url = `survey/email-delivery-setting/${props.surveyToken}/`
  const setting = useAxios({ url, skip: props.surveyToken === undefined })
  const update = useAxios({ url, method: 'patch', skip: true })

  const updateEmailDeliverySetting = {
    loading: update.loading,
    success: setting.data != null,
    error: Boolean(update.error),
    callApi: (data) =>
      update
        .fetch({ data })
        .then((response) => mutate(url, response.data, false))
        .catch(() => undefined),
  }

  return (
    <SurveySettingsHeader
      {...props}
      emailDeliverySetting={{ ...setting.data }}
      updateEmailDeliverySetting={updateEmailDeliverySetting}
    />
  )
}

export default withRouter(SurveySettingsHeaderContainer)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/SurveySettingsHeader.js